export const SmsNonMembersTypes = {
  SHOW_SMS_NON_MEMBERS: "SHOW_SMS_NON_MEMBERS",
  ADD_SMS_NON_MEMBERS: "ADD_SMS_NON_MEMBERS",
  DELETE_SMS_NON_MEMBERS: "DELETE_SMS_NON_MEMBERS",
  UPDATE_SMS_NON_MEMBERS: "UPDATE_SMS_NON_MEMBERS",
};
